import { useEffect, useState } from "react";
import { Loader2, Phone, MessageCircle, Mail } from "lucide-react";
import { adminAxios } from "../../lib/adminApi";

export default function AdminQuotes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await adminAxios.get("/admin/quotes");
        setItems(data.quotes || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="admin-quotes-page" className="space-y-6">
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900">Lead Inbox</h1>
        <p className="text-slate-500 text-sm mt-1">All quote requests submitted via your site.</p>
      </div>

      {loading ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-[#1C6B8A]" /></div>
      ) : items.length === 0 ? (
        <div className="bg-white rounded-2xl border border-slate-100 p-12 text-center text-slate-500 card-soft">
          No leads yet. New submissions will appear here.
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-100 card-soft overflow-hidden">
          <div className="divide-y divide-slate-100" data-testid="quotes-list">
            {items.map((q) => (
              <div key={q.id} className="p-5 flex flex-wrap items-start gap-4" data-testid={`quote-row-${q.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-semibold text-slate-900">{q.name}</div>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-[#E8F4F8] text-[#1C6B8A] text-[11px] font-semibold">
                      {q.service}
                    </span>
                  </div>
                  {q.address && <div className="text-xs text-slate-500 mt-1">{q.address}</div>}
                  {q.message && <div className="text-sm text-slate-700 mt-2 leading-relaxed">{q.message}</div>}
                  <div className="text-[11px] text-slate-400 mt-2">
                    {new Date(q.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <a
                    href={`tel:+91${q.phone.replace(/\D/g, "")}`}
                    className="h-9 w-9 rounded-full brand-btn flex items-center justify-center"
                    title="Call"
                  >
                    <Phone className="w-4 h-4" />
                  </a>
                  <a
                    href={`https://wa.me/91${q.phone.replace(/\D/g, "")}?text=${encodeURIComponent(`Hi ${q.name}, thanks for your enquiry about ${q.service}.`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="h-9 w-9 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:bg-[#1eb355]"
                    title="WhatsApp"
                  >
                    <MessageCircle className="w-4 h-4" />
                  </a>
                  {q.email && (
                    <a
                      href={`mailto:${q.email}`}
                      className="h-9 w-9 rounded-full bg-slate-900 text-white flex items-center justify-center"
                      title="Email"
                    >
                      <Mail className="w-4 h-4" />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
